var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.relationResource && _vm.newRecord && _vm.newRecord.id
        ? _c("base-form", {
            attrs: {
              resource: _vm.relationResource,
              "is-modal": true,
              id: _vm.newRecord.id,
              compare: !_vm.liveRecordEmpty && !_vm.newRecordEmpty,
              "pending-approval": _vm.liveRecordEmpty,
              "compare-id":
                _vm.petaLiveRecord && _vm.petaLiveRecord.id
                  ? _vm.petaLiveRecord.id
                  : 0
            }
          })
        : _vm._e(),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }